import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=1fd1f2bf&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=ts"
export * from "./Notifications.vue?vue&type=script&lang=ts"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=1fd1f2bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd1f2bf",
  null
  
)

export default component.exports